import { SVGProps } from "react";

const SvgStartingScreenIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#818C99"
        fillRule="nonzero"
        d="m12.128 5.116-5.102 4.02A2.688 2.688 0 0 0 6 11.25v6.853c0 .495.402.897.897.897h3.59a.898.898 0 0 0 .898-.897v-3.59c0-.1.08-.18.18-.18h1.794c.1 0 .18.08.18.18v3.59c0 .495.401.897.897.897h3.59a.898.898 0 0 0 .897-.897V11.25c0-.825-.378-1.604-1.026-2.115l-5.102-4.02a.54.54 0 0 0-.667 0zm.333 1.108 4.77 3.757.066.056c.348.306.55.747.55 1.213v6.673h-3.232v-3.41c0-.694-.562-1.257-1.256-1.257h-1.795l-.069.002a1.256 1.256 0 0 0-1.187 1.255v3.41H7.077V11.25c0-.495.227-.962.616-1.269l4.768-3.757z"
      />
    </g>
  </svg>
);
export default SvgStartingScreenIcon;
